// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EventDetails .row {
  margin-bottom: 8px;
}
.EventDetails .row.extra-space {
  margin-top: 8px;
}
.EventDetails .details-header {
  display: flex;
  align-items: center;
}
.EventDetails .details-title {
  font-size: 14px;
  font-weight: 900;
}`, "",{"version":3,"sources":["webpack://./src/web/client/src/components/Programs/Events/Sidebar/EventDetails.scss"],"names":[],"mappings":"AAEE;EACE,kBAAA;AADJ;AAGI;EACE,eAAA;AADN;AAKE;EACE,aAAA;EACA,mBAAA;AAHJ;AAME;EACE,eAAA;EACA,gBAAA;AAJJ","sourcesContent":[".EventDetails {\n\n  .row {\n    margin-bottom: 8px;\n\n    &.extra-space {\n      margin-top: 8px;\n    }\n  }\n\n  .details-header {\n    display: flex;\n    align-items: center;\n  }\n\n  .details-title {\n    font-size: 14px;\n    font-weight: 900;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
